import { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ProLayout, PageContainer } from '@ant-design/pro-components';
import { Button, Modal, Typography, message } from 'antd';
import { ApiOutlined, DashboardOutlined, FileSearchOutlined, FileTextOutlined, LogoutOutlined, ReadOutlined } from '@ant-design/icons';
import { TOKEN_KEY, api } from '../services/api';

const routes = [
  { path: '/', name: '运营概览', icon: <DashboardOutlined /> },
  { path: '/providers', name: 'LLM 模型管理', icon: <ApiOutlined /> },
  { path: '/readings', name: '命盘查询记录', icon: <FileSearchOutlined /> },
  { path: '/logs', name: '解读与调用日志', icon: <FileTextOutlined /> },
  { path: '/terminology', name: '术语库管理', icon: <ReadOutlined /> },
];

function ensureToken(): boolean {
  if (sessionStorage.getItem(TOKEN_KEY)) return true;
  const token = window.prompt('请输入管理端访问令牌');
  if (token) { sessionStorage.setItem(TOKEN_KEY, token); return true; }
  return false;
}

export function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [authRequired, setAuthRequired] = useState(false);
  useEffect(() => {
    if (import.meta.env.VITE_REQUIRE_ADMIN_TOKEN === 'true' && !ensureToken()) setAuthRequired(true);
    const handle = () => setAuthRequired(true);
    window.addEventListener('ling:auth-required', handle);
    return () => window.removeEventListener('ling:auth-required', handle);
  }, []);
  const retry = () => { if (ensureToken()) { setAuthRequired(false); window.location.reload(); } };
  return <ProLayout
    title="聆 · Ling"
    logo={false}
    location={{ pathname: location.pathname }}
    route={{ routes }}
    menuItemRender={(item, dom) => <Link to={item.path || '/'}>{dom}</Link>}
    avatarProps={{ render: () => <Button type="text" icon={<LogoutOutlined />} onClick={() => { sessionStorage.removeItem(TOKEN_KEY); message.success('已退出'); navigate('/'); }}>退出</Button> }}
    actionsRender={() => <Typography.Text type="secondary">运营控制台</Typography.Text>}
  >
    <PageContainer title={false}><Outlet /></PageContainer>
    <Modal open={authRequired} title="需要重新验证" onOk={retry} onCancel={() => setAuthRequired(false)}><Typography.Paragraph>当前令牌无效或已过期，请重新输入管理令牌。</Typography.Paragraph></Modal>
  </ProLayout>;
}
